// =============================================================
// CTマニュアル（使い方ガイド）
// Claude Design「CTマニュアル.dc.html」を素のJSへ移植したもの。
// 先頭の注意事項（テキストのみ・確認チェックでNEXT解放）＋ステップの画像＋ピン注釈＋凡例＋前/次ナビ。
// レスポンシブ（横長=左右／縦長=上下）。
// 画像URLは Liquid 側 window.CT_MANUAL_ASSETS（asset_url）から受け取る。
// 閉じると window.__TSHIRT_DESIGNER__.showPrintShapeModalOnce() を呼び、印刷範囲の形選択へ。
// #designer-help-btn（「?」）で再表示。
// =============================================================
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const root = document.getElementById('ct-manual');
    if (!root) return;

    // 画像設定は #ct-manual の data-assets（JSON）から取得。旧 window.CT_MANUAL_ASSETS もフォールバックで許容。
    let A = {};
    try {
      if (root.dataset && root.dataset.assets) A = JSON.parse(root.dataset.assets);
      else if (window.CT_MANUAL_ASSETS) A = window.CT_MANUAL_ASSETS;
    } catch (e) {
      A = window.CT_MANUAL_ASSETS || {};
    }
    const ACCENT = '#E60013';
    let step = 0;
    let aw = 0, ah = 0, isLandscape = false;
    let remeasuring = false; // render内の再計測再帰ガード
    // 注意事項の確認状態。一度チェックしたらセッション中は保持し、「?」からの再表示で再チェックを求めない。
    let noticeConfirmed = false;

    // スキーマ設定（image_picker）から src / 実寸(w,h) を受け取る。未設定時は既定サイズにフォールバック。
    function imgOf(key, w, h) {
      const a = A[key] || {};
      return { src: a.src || '', w: (a.w > 0 ? a.w : w), h: (a.h > 0 ? a.h : h) };
    }

    // 注意事項の本文はスキーマ設定（richtext）から受け取る。未設定時は仮テキスト。
    // richtextはHTML（<p>〜</p>）で渡ってくる。旧textarea形式（プレーンテキスト・改行区切り）にも対応する。
    const NOTICE_FALLBACK = 'ここに注意事項のテキストが入ります。テーマエディタのTシャツデザイナーセクション設定「注意事項テキスト」で編集してください。';
    const noticeText = (typeof A.notice === 'string' && A.notice.trim()) ? A.notice : NOTICE_FALLBACK;
    const noticeIsHtml = /<\w+[^>]*>/.test(noticeText);

    // レイヤーパネルのドラッグハンドル（6点グリップ）アイコン。本文中にインライン表示する。
    const DRAG_HANDLE_SVG = '<svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:1.3em;height:1.3em;vertical-align:-0.25em;">'
      + '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 8C10.3284 8 11 7.32843 11 6.5C11 5.67157 10.3284 5 9.5 5C8.67157 5 8 5.67157 8 6.5C8 7.32843 8.67157 8 9.5 8ZM9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14ZM11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5ZM15.5 8C16.3284 8 17 7.32843 17 6.5C17 5.67157 16.3284 5 15.5 5C14.6716 5 14 5.67157 14 6.5C14 7.32843 14.6716 8 15.5 8ZM17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z" fill="#121923"></path>'
      + '</svg>';

    // レイヤーパネルの鍵（ロック）ボタンのアイコン。本文中にインライン表示する（icon-lock と同一）。
    const LOCK_SVG = '<svg viewBox="0 0 384 512" style="width:1.05em;height:1.05em;vertical-align:-0.15em;fill:currentColor;">'
      + '<path d="M128 96l0 64 128 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zM64 160l0-64C64 25.3 121.3-32 192-32S320 25.3 320 96l0 64c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64z"/>'
      + '</svg>';

    // 戻る/進む・磁石（スナップ）ボタンのアイコン。本文中にインライン表示する（ボタンと同一）。
    const UNDO_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:1.15em;height:1.15em;vertical-align:-0.25em;">'
      + '<path d="M9 7L4 12l5 5"></path><path d="M4 12h11a5 5 0 0 1 0 10h-1"></path></svg>';
    const REDO_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:1.15em;height:1.15em;vertical-align:-0.25em;">'
      + '<path d="M15 7l5 5-5 5"></path><path d="M20 12H9a5 5 0 0 0 0 10h1"></path></svg>';
    const MAGNET_SVG = '<svg viewBox="0 0 448 512" style="width:1.05em;height:1.05em;vertical-align:-0.15em;fill:currentColor;">'
      + '<path d="M0 176L0 288C0 411.7 100.3 512 224 512S448 411.7 448 288l0-112-128 0 0 112c0 53-43 96-96 96s-96-43-96-96l0-112-128 0zm0-48l128 0 0-64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64zm320 0l128 0 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64z"/></svg>';

    const DATA = [
      {
        type: 'notice', num: '', title: 'ご利用前の注意事項', sub: '',
        img: { src: '', w: 0, h: 0 }, // テキストのみ（画像エリアはDOMへ追加しない）

        body: noticeIsHtml ? [] : noticeText.split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean),
        bodyHtml: noticeIsHtml ? noticeText : '',
        requireConfirm: true,
        pins: [], legend: []
      },
      {
        num: '1', title: 'プリントする範囲の形を選ぶ', sub: '',
        img: imgOf('step1', 814, 1172),
        body: [
          '印刷可能範囲を「全体」「丸」「三角」「カスタム」から選べます。選んだ形の内側が、デザイン・印刷できる範囲になります。',
          '「カスタム」を選ぶと、次の画面で図形を自由に組み合わせて範囲を作れます。'
        ],
        pins: [], legend: []
      },
      {
        num: '1-2', title: '印刷したい範囲をつくる', sub: '「カスタム」を選んだとき',
        img: imgOf('step1_5', 814, 1174),
        body: ['図形（丸・三角・四角）を組み合わせて、印刷できる範囲を自由に作成できます。動かす・大きさ変更・回転もできます。'],
        pins: [], legend: []
      },
      {
        num: '2', title: 'ツールを使ってデザインを作成', sub: '',
        img: imgOf('step2_tools', 796, 187),
        body: ['画面下のツールで素材を選び、印刷範囲にデザインを作成します。'],
        pins: [], legend: []
      },
      {
        num: '2-2', title: '配置した素材の一覧表示と便利なツール', sub: '',
        img: imgOf('step2_full', 812, 1172),
        body: ['配置中の素材一覧を表示。タップで選択／鍵で固定／ゴミ箱で削除。左端を長押しドラッグで重なり順を変更できます。'],
        pins: [], legend: []
      },
      {
        num: '2-3', title: '重なり順の変更について', sub: '',
        img: imgOf('step2_extra', 812, 1172),
        // 「長押しする箇所」はレイヤーパネルの実際のドラッグハンドル（6点グリップ）アイコンをインライン表示する
        bodyHtml: '<p>重なり順を変更したい素材の「左端の点々（' + DRAG_HANDLE_SVG + '）」を長押ししながら上下に移動させることで重なり順を変更できます。</p>',
        pins: [], legend: []
      },
      {
        num: '2-4', title: '素材のロック（固定）について', sub: '',
        img: imgOf('step2_lock', 812, 1172),
        // 鍵ボタンはレイヤーパネルの実際のロックアイコンをインライン表示する
        bodyHtml: '<p>配置した素材は、素材一覧の鍵ボタン（' + LOCK_SVG + '）をタップすると<strong>ロック（固定）</strong>できます。</p>'
          + '<p>ロック中の素材は、移動・拡大縮小・回転・選択ができなくなります。他の素材を編集するときに、間違えて動かしてしまうのを防げます。</p>'
          + '<p>もう一度鍵ボタン（' + LOCK_SVG + '）をタップすると解除され、また編集できるようになります。</p>',
        pins: [], legend: []
      },
      {
        num: '2-5', title: '表示・色を調整するツール', sub: '',
        img: imgOf('step2_side', 368, 588),
        body: ['画面右端のボタンから、印刷範囲の再設定、印刷範囲の拡大／縮小（表示切り替え）、色の変更（対応素材のみ）ができます。'],
        pins: [], legend: []
      },
      {
        num: '2-6', title: '操作の「戻る・進む」／スナップ', sub: '',
        img: imgOf('step2_undo_snap', 812, 1172),
        // 左上のボタン群（戻る・進む・磁石＝スナップ）を本文中にインラインアイコンで説明する
        bodyHtml: '<p>画面左上のボタンで、直前の操作を「戻す（' + UNDO_SVG + '）」・「やり直す（' + REDO_SVG + '）」ことができます。</p>'
          + '<p>磁石ボタン（' + MAGNET_SVG + '）でスナップのオン／オフを切り替えられます。オンのときは、素材を動かしたり大きさを変えたりすると、印刷範囲の中心や枠にぴったり吸い付いて、まっすぐ・きれいに配置できます。</p>',
        pins: [], legend: []
      },
      {
        num: '3', title: 'デザインの決定・注文', sub: '',
        img: imgOf('step2_done', 803, 176),
        body: ['デザインが完成したら「完了」をタップし、表示される「この内容で決定」ボタンをタップしてデザインを確定します。'],
        pins: [], legend: []
      },
      {
        num: '3-2', title: 'QRコードでカートへ追加', sub: '',
        img: imgOf('step3_5_qr', 802, 1162),
        body: [
          '注意事項の確認後に表示されるQRコードを、ご自身のスマートフォンで読み込んでください。',
          'B-SIDE LABEL 公式WEBSHOP のカートに、作成したデザインが自動で追加されます。'
        ],
        warning: 'カートへの追加が確認できるまで、QRコードの画面を閉じないでください。',
        pins: [], legend: []
      }
    ];
    const TOTAL = DATA.length;

    const DIRS = {
      l: { dx: -46, dy: 0, axis: 'h' }, r: { dx: 46, dy: 0, axis: 'h' },
      u: { dx: 0, dy: -42, axis: 'v' }, d: { dx: 0, dy: 42, axis: 'v' }
    };

    function toneOf(k) { return k === 'dark' ? '#1a1a1a' : (k === 'blue' ? '#1479FF' : ACCENT); }
    function setStyle(n, s) { if (s) { for (const k in s) n.style[k] = s[k]; } }
    function el(tag, style, text) {
      const n = document.createElement(tag);
      if (style) setStyle(n, style);
      if (text != null) n.textContent = text;
      return n;
    }

    // ---- ピン（枠 / リング＋引き出し線＋ラベル）----
    function buildPin(p, c) {
      if (p.type === 'box') {
        const twoB = String(p.n).length > 1;
        const box = el('div', {
          position: 'absolute', left: p.x + '%', top: p.y + '%', width: p.w + '%', height: p.h + '%',
          border: '2.5px solid ' + c, background: c + '22', borderRadius: '7px',
          boxShadow: '0 0 0 2px rgba(255,255,255,.7)', boxSizing: 'border-box', zIndex: '6'
        });
        const label = el('div', {
          position: 'absolute', left: '0px', top: '0px', transform: 'translate(-50%,-50%)',
          width: '30px', height: '30px', borderRadius: '50%', background: c, color: '#fff',
          border: '2.5px solid #fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: twoB ? '11px' : '15px', fontWeight: '700', lineHeight: '1', whiteSpace: 'nowrap',
          boxShadow: '0 3px 11px rgba(0,0,0,.34)', zIndex: '2'
        }, p.n);
        box.appendChild(label);
        return box;
      }
      const off = DIRS[p.dir || 'u'];
      const wrap = el('div', { position: 'absolute', left: p.x + '%', top: p.y + '%', width: '0px', height: '0px', zIndex: '6' });
      const ring = el('div', {
        position: 'absolute', left: '0px', top: '0px', transform: 'translate(-50%,-50%)',
        width: '26px', height: '26px', borderRadius: '50%', border: '2.5px solid ' + c, background: 'transparent',
        boxShadow: '0 0 0 2.5px rgba(255,255,255,.9), 0 2px 7px rgba(0,0,0,.3)', boxSizing: 'border-box'
      });
      let line;
      if (off.axis === 'h') {
        const len = Math.abs(off.dx) - 28;
        line = el('div', { position: 'absolute', top: '0px', height: '2.5px', background: c, transform: 'translateY(-50%)', width: len + 'px', left: (off.dx > 0 ? 14 : (off.dx + 14)) + 'px' });
      } else {
        const len = Math.abs(off.dy) - 28;
        line = el('div', { position: 'absolute', left: '0px', width: '2.5px', background: c, transform: 'translateX(-50%)', height: len + 'px', top: (off.dy > 0 ? 14 : (off.dy + 14)) + 'px' });
      }
      const labelBase = {
        position: 'absolute', left: '0px', top: '0px',
        transform: 'translate(calc(-50% + ' + off.dx + 'px), calc(-50% + ' + off.dy + 'px))',
        boxShadow: '0 3px 11px rgba(0,0,0,.34)', zIndex: '2'
      };
      let label;
      if (p.text) {
        label = el('div', Object.assign({}, labelBase, {
          background: c, color: '#fff', padding: '7px 12px', borderRadius: '999px',
          fontSize: '13px', fontWeight: '700', whiteSpace: 'nowrap'
        }), p.text);
      } else {
        const two = String(p.n).length > 1;
        label = el('div', Object.assign({}, labelBase, {
          width: '30px', height: '30px', borderRadius: '50%', background: c, color: '#fff',
          border: '2.5px solid #fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: two ? '11px' : '15px', fontWeight: '700', lineHeight: '1', whiteSpace: 'nowrap'
        }), p.n);
      }
      wrap.appendChild(ring);
      wrap.appendChild(line);
      wrap.appendChild(label);
      return wrap;
    }

    function render() {
      const showCounter = window.CT_MANUAL_SHOW_COUNTER !== false;
      const i = Math.min(step, TOTAL - 1);
      const cur = DATA[i];
      const isNotice = cur.type === 'notice'; // テキストのみ（画像エリアなし）＋確認チェック
      const isL = isLandscape;
      const pad = isL ? 34 : 12;

      root.innerHTML = '';
      setStyle(root, {
        position: 'fixed', inset: '0px', display: 'flex', flexDirection: isL ? 'row' : 'column',
        background: '#ffffff', color: '#1a1a1a', fontFamily: "'Noto Sans JP', sans-serif", overflow: 'hidden', zIndex: '95'
      });

      // 閉じるボタン
      const closeBtn = el('button', {
        position: 'absolute', top: '14px', right: '14px', width: '42px', height: '42px', borderRadius: '50%',
        border: 'none', background: 'rgba(255,255,255,.92)', boxShadow: '0 2px 12px rgba(0,0,0,.16)',
        cursor: 'pointer', fontSize: '22px', color: '#333', display: 'flex', alignItems: 'center',
        justifyContent: 'center', zIndex: '20', lineHeight: '1'
      }, '×');
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', '閉じる');
      closeBtn.addEventListener('click', closeManual);
      // 注意事項スライド表示中は閉じるボタンを出さない（確認チェック＋NEXTでのみ先へ進める）
      if (!isNotice) root.appendChild(closeBtn);

      // 画像サイズ算出（画像は正方形前提）
      // 横長: 画像エリア（flex）に対して正方形フィット（エリアの実測に依存）
      // 縦長: 画面幅基準で少し大きめ。エリアは画像にフィットさせ、上下のグレー余白を無くす
      const ready = isL ? (aw > 0 && ah > 0) : true;
      let side;
      if (isL) {
        const availW = Math.max(10, aw - pad * 2);
        const availH = Math.max(10, ah - pad * 2);
        side = Math.round(Math.min(availW, availH));
      } else {
        // 画面幅の約0.9。ただし画面高さの48%は超えない（縦長でも大きくなりすぎない）
        side = Math.round(Math.min((window.innerWidth - pad * 2) * 0.9, window.innerHeight * 0.48));
      }

      // 画像エリア（縦長は画像に高さをフィット＝余白なし、横長は残り領域を使う）
      const areaStyle = {
        position: 'relative', minWidth: '0', minHeight: '0', display: 'flex',
        alignItems: 'center', justifyContent: 'center', background: '#eeedf0', padding: pad + 'px', overflow: 'hidden'
      };
      if (isL) {
        areaStyle.flex = '1 1 auto';
      } else {
        areaStyle.flex = 'none';
        areaStyle.height = (side + pad * 2) + 'px';
      }
      const area = el('div', areaStyle);
      area.setAttribute('data-area', '1');

      let imgWrapStyle = {
        position: 'relative', flex: 'none', width: side + 'px', height: side + 'px',
        opacity: ready ? '1' : '0', transition: 'opacity .2s ease'
      };
      const imgWrap = el('div', imgWrapStyle);
      const primary = el('div', {
        width: '100%', height: '100%', backgroundColor: '#fff',
        backgroundImage: cur.img.src ? ('url("' + cur.img.src + '")') : 'none',
        backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',
        borderRadius: '6px', boxShadow: '0 8px 34px rgba(0,0,0,.14)'
      });
      primary.setAttribute('role', 'img');
      imgWrap.appendChild(primary);
      (cur.pins || []).forEach(function (p) { imgWrap.appendChild(buildPin(p, toneOf(p.tone))); });
      area.appendChild(imgWrap);

      // インセット（補足画像）
      if (cur.inset && ready) {
        const maxW = isL ? Math.min(380, aw * 0.46) : Math.min(320, aw * 0.64);
        const w = Math.min(cur.inset.w, maxW);
        const card = el('div', {
          position: 'absolute', left: (isL ? '22px' : '12px'), bottom: (isL ? '22px' : '14px'), width: w + 'px',
          background: '#fff', border: '1px solid #e2e2e6', borderRadius: '11px',
          boxShadow: '0 12px 34px rgba(0,0,0,.2)', padding: '7px', zIndex: '8'
        });
        const im = el('div', {
          display: 'block', width: '100%', height: (w * cur.inset.h / cur.inset.w) + 'px', backgroundColor: '#fff',
          backgroundImage: cur.inset.src ? ('url("' + cur.inset.src + '")') : 'none',
          backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', borderRadius: '5px'
        });
        const cap = el('div', {
          fontSize: '11px', fontWeight: '700', color: '#fff', background: ACCENT, borderRadius: '999px',
          padding: '4px 10px', display: 'inline-block', marginTop: '7px'
        }, cur.inset.caption);
        card.appendChild(im);
        card.appendChild(cap);
        area.appendChild(card);
      }
      // 注意事項スライドはテキストのみ（画像エリアを付けない）
      if (!isNotice) root.appendChild(area);

      // テキストパネル
      // 横長: 幅40%固定（画像=残り60%）。縦長: 画像エリアを画像高さにフィットさせ、テキストは残り全部（flex:1 1 auto）。
      // 高さ/幅が固定またはステップ非依存なので、ステップ移動で画像サイズは可変しない。長文は textInner でスクロール。
      const textPanel = el('div', isL
        ? { position: 'relative', flex: 'none', width: '40%', background: '#fff', borderLeft: '1px solid #e7e7ea', display: 'flex', flexDirection: 'column', padding: '40px 36px 28px', overflow: 'hidden' }
        : { position: 'relative', flex: '1 1 auto', width: '100%', minHeight: '0', background: '#fff', borderTop: '1px solid #e7e7ea', display: 'flex', flexDirection: 'column', padding: '20px 22px 18px', overflow: 'hidden' });
      // 注意事項スライドは画像エリアがないため、テキストパネルを全幅にして読みやすい余白を取る
      if (isNotice) {
        setStyle(textPanel, { width: '100%', borderLeft: 'none' });
        if (isL) setStyle(textPanel, { padding: '48px 14% 28px' });
      }

      const inner = el('div', { flex: '1 1 auto', overflowY: 'auto', paddingRight: '4px' });

      // 注意事項スライドは本文ブロックを上下左右中央に配置する（ブロック内の文字は左寄せのまま）。
      // margin:auto方式なら本文が画面より長い場合も先頭が切れずスクロールできる。
      let content = inner;
      if (isNotice) {
        setStyle(inner, { display: 'flex', flexDirection: 'column' });
        content = el('div', { margin: 'auto', maxWidth: '640px', width: '100%' });
        inner.appendChild(content);
      }

      // 「使い方ガイド」ラベルは注意事項スライドでは表示しない
      if (!isNotice) {
        inner.appendChild(el('div', { fontSize: '12px', fontWeight: '700', letterSpacing: '.22em', color: '#b4b4ba', marginBottom: '12px' }, '使い方ガイド'));
      }

      // STEP番号行（注意事項スライドなど num が空のページでは表示しない）
      if (cur.num) {
        const stepRow = el('div', { display: 'flex', alignItems: 'flex-end', gap: '10px', marginBottom: '10px', flexWrap: 'wrap' });
        stepRow.appendChild(el('span', { fontSize: '15px', fontWeight: '700', letterSpacing: '.16em', color: '#9a9aa0' }, 'STEP'));
        stepRow.appendChild(el('span', { fontSize: isL ? '42px' : '34px', fontWeight: '900', color: ACCENT, lineHeight: '1' }, cur.num));
        // サブ（例:「カスタム」を選んだとき）は STEP 番号の横に表示
        if (cur.sub) {
          stepRow.appendChild(el('span', {
            fontSize: '12px', fontWeight: '700', letterSpacing: '.04em', color: ACCENT,
            border: '1px solid ' + ACCENT, borderRadius: '999px', padding: '3px 11px', whiteSpace: 'nowrap'
          }, cur.sub));
        }
        inner.appendChild(stepRow);
      }

      content.appendChild(el('div', { width: '34px', height: '4px', background: ACCENT, borderRadius: '2px', margin: '14px 0 14px' }));
      // 注意事項スライドはタイトル・本文とも一回り大きく表示する
      content.appendChild(el('h2', {
        fontSize: isNotice ? (isL ? '32px' : '26px') : (isL ? '27px' : '22px'),
        fontWeight: '700', lineHeight: '1.45', margin: '0 0 14px', color: '#1a1a1a', letterSpacing: '.01em'
      }, cur.title));

      (cur.body || []).forEach(function (t) {
        content.appendChild(el('p', {
          fontSize: isNotice ? (isL ? '19px' : '16px') : (isL ? '15px' : '14px'),
          lineHeight: '1.95', color: '#4a4a50', margin: isNotice ? '0 0 14px' : '0 0 10px'
        }, t));
      });

      // リッチテキスト本文（richtext設定のHTML）。テーマエディタで入力した装飾（太字・リンク・リスト等）を反映する。
      // 出力はスタッフが管理画面で入力した設定値のみ（ユーザー入力は含まない）。
      if (cur.bodyHtml) {
        const rich = el('div', {
          fontSize: isNotice ? (isL ? '19px' : '16px') : (isL ? '15px' : '14px'),
          lineHeight: '1.95', color: '#4a4a50'
        });
        rich.innerHTML = cur.bodyHtml;
        rich.querySelectorAll('p').forEach(function (p) { setStyle(p, { margin: isNotice ? '0 0 14px' : '0 0 10px' }); });
        rich.querySelectorAll('ul, ol').forEach(function (l) { setStyle(l, { margin: isNotice ? '0 0 14px' : '0 0 10px', paddingLeft: '1.4em' }); });
        content.appendChild(rich);
      }

      if (cur.note) {
        content.appendChild(el('div', {
          background: 'rgba(20,121,255,.10)', color: '#0b5bd0', fontWeight: '700', fontSize: '14px', lineHeight: '1.7',
          padding: '12px 14px', borderRadius: '10px', marginTop: '6px'
        }, '＊ ' + cur.note));
      }

      if ((cur.legend || []).length) {
        const legendWrap = el('div', { marginTop: '8px' });
        cur.legend.forEach(function (lg) {
          const c = toneOf(lg.tone);
          const two = String(lg.n).length > 1;
          const row = el('div', { display: 'flex', gap: '12px', alignItems: 'flex-start', padding: '11px 0', borderTop: '1px solid #efeff1' });
          row.appendChild(el('div', {
            flex: 'none', width: '26px', height: '26px', borderRadius: '50%', background: c, color: '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: two ? '10px' : '13px',
            fontWeight: '700', marginTop: '1px', lineHeight: '1', whiteSpace: 'nowrap'
          }, lg.n));
          const txt = el('div', { flex: '1 1 auto', minWidth: '0' });
          txt.appendChild(el('div', { fontSize: '14px', fontWeight: '700', color: '#1a1a1a', marginBottom: '3px' }, lg.t));
          txt.appendChild(el('div', { fontSize: '13px', lineHeight: '1.7', color: '#5a5a60' }, lg.d));
          row.appendChild(txt);
          legendWrap.appendChild(row);
        });
        content.appendChild(legendWrap);
      }

      if (cur.warning) {
        content.appendChild(el('div', {
          background: '#faf1f1', color: ACCENT, fontWeight: '700', fontSize: '14px', lineHeight: '1.7',
          padding: '12px 14px', borderRadius: '10px', marginTop: '14px'
        }, '⚠ ' + cur.warning));
      }

      // 確認チェックボックス（注意事項スライド）。チェックするまでNEXTを押せない。
      if (cur.requireConfirm) {
        const confirmRow = el('label', {
          display: 'flex', alignItems: 'center', gap: '12px', marginTop: '20px',
          padding: '14px 16px', borderRadius: '12px', cursor: 'pointer', userSelect: 'none',
          border: '1.5px solid ' + (noticeConfirmed ? ACCENT : '#d3d3d8'),
          background: noticeConfirmed ? 'rgba(230,0,19,.05)' : '#fff'
        });
        const cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.checked = noticeConfirmed;
        setStyle(cb, { flex: 'none', width: '26px', height: '26px', margin: '0', accentColor: ACCENT, cursor: 'pointer' });
        cb.addEventListener('change', function () {
          noticeConfirmed = cb.checked;
          setStyle(confirmRow, {
            borderColor: noticeConfirmed ? ACCENT : '#d3d3d8',
            background: noticeConfirmed ? 'rgba(230,0,19,.05)' : '#fff'
          });
          if (typeof root.__gateNext === 'function') root.__gateNext();
        });
        confirmRow.appendChild(cb);
        confirmRow.appendChild(el('span', { fontSize: '18px', fontWeight: '700', color: '#1a1a1a' }, '内容を確認しました'));
        content.appendChild(confirmRow);
      }

      textPanel.appendChild(inner);

      // ナビゲーション
      const nav = el('div', { flex: 'none', paddingTop: '16px' });
      // 注意事項スライドではナビ（戻る/NEXT・ドット）も本文ブロックと同じ幅（最大640px・中央）に揃える
      if (isNotice) setStyle(nav, { width: '100%', maxWidth: '640px', margin: '0 auto' });
      const btnRow = el('div', { display: 'flex', gap: '10px', alignItems: 'center' });
      const prevDisabled = i === 0;
      const prevBtn = el('button', Object.assign({
        flex: '0 0 auto', padding: '0 20px', height: '52px', borderRadius: '999px', border: '1.5px solid #d3d3d8',
        background: '#fff', color: '#1a1a1a', fontWeight: '700', fontSize: '14px', cursor: 'pointer'
      }, prevDisabled ? { opacity: '.32', pointerEvents: 'none' } : {}), '← 戻る');
      prevBtn.type = 'button';
      prevBtn.addEventListener('click', prev);
      const nextBtn = el('button', {
        flex: '1 1 auto', height: '52px', borderRadius: '999px', border: 'none', background: '#1a1a1a',
        color: '#fff', fontWeight: '700', fontSize: '16px', letterSpacing: '.06em', cursor: 'pointer'
      }, i === TOTAL - 1 ? 'とじる' : 'NEXT');
      nextBtn.type = 'button';
      nextBtn.addEventListener('click', next);
      // 注意事項スライドでは、チェックが入るまでNEXTを無効化する
      const gateNext = function () {
        const locked = !!cur.requireConfirm && !noticeConfirmed;
        nextBtn.disabled = locked;
        nextBtn.style.opacity = locked ? '.32' : '1';
        nextBtn.style.cursor = locked ? 'default' : 'pointer';
      };
      root.__gateNext = gateNext;
      gateNext();
      btnRow.appendChild(prevBtn);
      btnRow.appendChild(nextBtn);
      nav.appendChild(btnRow);

      const dotsRow = el('div', { display: 'flex', gap: '7px', alignItems: 'center', justifyContent: 'center', marginTop: '16px' });
      for (let d = 0; d < TOTAL; d++) {
        dotsRow.appendChild(el('div', {
          height: '7px', borderRadius: '999px', transition: 'all .25s ease',
          width: d === i ? '24px' : '7px', background: d === i ? ACCENT : '#d3d3d8'
        }));
      }
      nav.appendChild(dotsRow);

      if (showCounter) {
        nav.appendChild(el('div', {
          textAlign: 'center', fontSize: '12px', fontWeight: '700', color: '#b0b0b6', letterSpacing: '.1em', marginTop: '10px'
        }, (i + 1) + ' / ' + TOTAL));
      }

      textPanel.appendChild(nav);
      root.appendChild(textPanel);

      // 注意事項スライドには画像エリアがなく、そこからの遷移直後は aw/ah が未計測（0）のまま
      // 描画される（＝画像が不可視になる）。描画後にエリア実寸とずれていたら、実寸を反映して
      // 同期的に一度だけ描画し直す。再描画では実寸と一致するため再帰は1段で止まる。
      if (!isNotice && !remeasuring) {
        const areaNow = root.querySelector('[data-area]');
        if (areaNow && (areaNow.clientWidth !== aw || areaNow.clientHeight !== ah)) {
          remeasuring = true;
          aw = areaNow.clientWidth;
          ah = areaNow.clientHeight;
          render();
          remeasuring = false;
        }
      }
    }

    function measure() {
      if (root.hidden) return; // 閉じている間は再描画しない（render が再表示してしまうのを防ぐ）
      isLandscape = window.innerWidth >= window.innerHeight;
      const area = root.querySelector('[data-area]');
      if (area) { aw = area.clientWidth; ah = area.clientHeight; }
      render();
    }

    function goTo(n) {
      if (n < 0 || n >= TOTAL || n === step) return;
      step = n;
      measure();
    }
    function next() {
      // 注意事項の未確認中は先へ進めない（キーボード操作のガードも兼ねる）
      if (DATA[step] && DATA[step].requireConfirm && !noticeConfirmed) return;
      if (step >= TOTAL - 1) closeManual(); else goTo(step + 1);
    }
    function prev() { if (step > 0) goTo(step - 1); }

    function show() {
      step = 0;
      root.hidden = false;
      root.style.display = 'flex'; // render で上書きするが、先に表示状態にしておく
      requestAnimationFrame(measure);
      [60, 200, 400].forEach(function (ms) { setTimeout(measure, ms); });
    }

    function closeManual() {
      root.hidden = true;
      // render が inline display:flex を付けるため、hidden だけでは消えない。明示的に非表示にする。
      root.style.display = 'none';
      const D = window.__TSHIRT_DESIGNER__;
      if (D && typeof D.showPrintShapeModalOnce === 'function') D.showPrintShapeModalOnce();
    }

    // ---- イベント ----
    window.addEventListener('resize', function () { if (!root.hidden) measure(); });
    window.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    });

    const helpBtn = document.getElementById('designer-help-btn');
    if (helpBtn) helpBtn.addEventListener('click', show);

    // 初期表示：window.load（全画像の読み込み完了）を待つと、画像が重いときにエディタだけが
    // 数秒先に見えてしまう。マニュアルの枠組みは即表示し（画像は後から埋まる）、必ずエディタより
    // 先に前面へ出す。レイアウト確定のための再計測は show() 内の rAF / タイマーで行う。
    root.hidden = true;
    show();
    // 念のため、load 後にも再計測（画像サイズ確定後のフィット微調整）。
    window.addEventListener('load', function () { setTimeout(measure, 50); });
  }
})();
